(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    document.querySelectorAll('[data-close-menu]').forEach(function (link) {
      link.addEventListener('click', function () {
        var menu = link.closest('details');
        if (menu) menu.removeAttribute('open');
      });
    });
    document.addEventListener('click', function (event) {
      var menu = document.querySelector('.mobile-menu[open]');
      if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var menu = document.querySelector('.mobile-menu[open]');
      if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stage = document.querySelector('[data-parallax]');
    if (!stage || window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hero = stage.closest('section');
    var frame = null;
    hero.addEventListener('mousemove', function (event) {
      var rect = hero.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width - 0.5;
      var y = (event.clientY - rect.top) / rect.height - 0.5;
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        stage.style.setProperty('--px', (x * -1.2).toFixed(3));
        stage.style.setProperty('--py', (y * -1.2).toFixed(3));
      });
    });
    hero.addEventListener('mouseleave', function () {
      stage.style.setProperty('--px', 0);
      stage.style.setProperty('--py', 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  const NEWSLETTER_KEY = 'fpr-fiche-choice';

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.newsletter__form');
    const checked = form && form.querySelector('.newsletter__choice input:checked');
    if (!checked) return;
    try {
      sessionStorage.setItem(NEWSLETTER_KEY, checked.dataset.choice);
    } catch (error) {}
  });

  document.querySelectorAll('.newsletter__success').forEach((success) => {
    let choice = null;
    try {
      choice = sessionStorage.getItem(NEWSLETTER_KEY);
    } catch (error) {}
    const links = success.querySelectorAll('[data-download]');
    if (choice === null || ![...links].some((link) => link.dataset.download === choice)) return;
    links.forEach((link) => {
      link.hidden = link.dataset.download !== choice;
    });
    const card = success.closest('.newsletter__card');
    card.querySelectorAll('[data-choice-sheet]').forEach((sheet) => {
      sheet.hidden = sheet.dataset.choiceSheet !== choice;
    });
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.newsletter__choice input');
    if (!input) return;
    const card = input.closest('.newsletter__card');
    card.querySelectorAll('[data-choice-sheet]').forEach((sheet) => {
      sheet.hidden = sheet.dataset.choiceSheet !== input.dataset.choice;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-preview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-preview-track]').forEach(function (track) {
    var section = track.closest('section');
    var dialog = section.querySelector('[data-preview-dialog]');
    var image = section.querySelector('[data-preview-image]');
    var caption = section.querySelector('[data-preview-caption]');
    var scrollByItem = function (direction) {
      var item = track.querySelector('.preview__item');
      var distance = item ? item.getBoundingClientRect().width + 24 : 300;
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };
    var prev = section.querySelector('[data-preview-prev]');
    var next = section.querySelector('[data-preview-next]');
    if (prev) prev.addEventListener('click', function () { scrollByItem(-1); });
    if (next) next.addEventListener('click', function () { scrollByItem(1); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); scrollByItem(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); scrollByItem(-1); }
    });
    section.querySelectorAll('[data-preview-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!dialog || typeof dialog.showModal !== 'function') { window.open(button.dataset.src, '_blank'); return; }
        image.src = button.dataset.src;
        image.alt = button.dataset.caption;
        caption.textContent = button.dataset.caption;
        dialog.showModal();
      });
    });
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');
        gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
          var active = slide.getAttribute('data-gallery-slide') === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
          var active = other === thumb;
          other.classList.toggle('is-active', active);
          if (active) other.setAttribute('aria-current', 'true'); else other.removeAttribute('aria-current');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
